import React, { useEffect, useRef } from 'react';
import StructuredContent from '@nerdwallet/structured-content-core';

interface Props {
  instagramURL: string;
}

const InstagramPlayer = ({ instagramURL }: Props): JSX.Element => {
  const wrapperRef = useRef<HTMLDivElement>(null);

  // a11y: set the title attribute for iframes
  useEffect(() => {
    const root = wrapperRef.current;
    if (!root) return;

    const setTitle = (iframe: HTMLIFrameElement) =>
      iframe.setAttribute('title', 'Instagram embed');

    // set it for iframes that already exist (SSR or cached load)
    root.querySelectorAll('iframe').forEach(setTitle);

    // watch for iframes that will be injected later
    const observer = new MutationObserver((records) => {
      records.forEach((rec) => {
        rec.addedNodes.forEach((node) => {
          if (node instanceof HTMLIFrameElement) {
            setTitle(node);
          } else if (node instanceof HTMLElement) {
            node.querySelectorAll('iframe').forEach(setTitle);
          }
        });
      });
    });

    observer.observe(root, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  return (
    <div ref={wrapperRef}>
      <StructuredContent>
        {{
          type: 'Instagram',
          version: '1.0.0',
          props: {
            url: instagramURL,
            maxWidth: 650,
            hideCaptions: true,
          },
        }}
      </StructuredContent>
    </div>
  );
};

export default InstagramPlayer;
